import React from 'react'
import { motion } from 'framer-motion'
import { WordLength } from '../types/game'

interface AlreadyPlayedViewProps {
  mode: string
  availableModes: WordLength[]
  resetTimeStr: string
  onModeSelect: (mode: WordLength) => void
  onBackToModes: () => void
}

export const AlreadyPlayedView: React.FC<AlreadyPlayedViewProps> = ({
  mode,
  availableModes,
  resetTimeStr,
  onModeSelect,
  onBackToModes,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="mode-selection"
      data-hj-allow="true"
    >
      <motion.h1
        className="mode-title"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {`${mode}-Letter Challenge`}
      </motion.h1>

      <div className="w-full max-w-lg mx-auto bg-[rgba(92,18,22,0.4)] rounded-lg p-6 mb-8 border border-[rgba(237,28,36,0.2)]">
        <h2 className="text-2xl font-bold mb-4 text-center">
          You've already played today!
        </h2>
        <p className="text-lg text-white/80 mb-6 text-center">
          Nice one! You've smashed the {mode}-letter challenge today. Come back
          at {resetTimeStr} to tackle a fresh zwizle!
        </p>

        {availableModes.length > 0 ? (
          <>
            <h3 className="text-xl font-semibold mb-4 text-center">
              Try these other challenges:
            </h3>

            <div className="grid gap-6 mb-8">
              {availableModes.map((availableMode) => (
                <button
                  key={availableMode}
                  onClick={() => onModeSelect(availableMode)}
                  className="play-button py-4"
                >
                  Play {availableMode}-Letter Challenge
                </button>
              ))}
            </div>
          </>
        ) : (
          <p className="text-lg text-white/60 mb-8 text-center">
            You've completed all of today's challenges!
          </p>
        )}

        <button onClick={onBackToModes} className="play-button w-full py-4">
          Back to Mode Selection
        </button>
      </div>
    </motion.div>
  )
}
